import React, { useState } from "react";

import { writeDay } from "./workWithData";

export const useDay = (initialDay) => {
    const [day, setDay] = useState(initialDay);

    const functionUpdater = (newDay) => {
        setDay(newDay);
        writeDay(newDay);
    };

    return [day, functionUpdater];
};
